import React from 'react';
import { BookOpenIcon, ClipboardListIcon, ImageIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const items = [{
  icon: BookOpenIcon,
  label: 'PDF',
  title: 'Libro del Método Pádel',
  desc: 'El método completo en PDF: cómo estructurar tus clases, progresar a cada alumno y ordenar tu año sin improvisar.'
}, {
  icon: ClipboardListIcon,
  label: 'PDF',
  title: 'Ejercicios con el Método',
  desc: 'El banco de ejercicios aplicados al método, organizados por objetivo y nivel. Abrís el PDF y tenés la clase resuelta.'
}, {
  icon: ImageIcon,
  label: 'Imágenes',
  title: 'Imágenes explicativas de golpes',
  desc: 'Cada golpe explicado visualmente para corregir técnica en pista y para compartir con tus alumnos.'
}];
export function PilatesContents() {
  return <section className="bg-padel-surface px-4 py-16 sm:py-24" data-id="element-140" data-mp="1jreh7s5pdhl5">
      <div className="mx-auto max-w-5xl" data-id="element-141" data-mp="1frnk76pl2586">
        <FadeIn data-id="element-142" data-mp="1fqkswxocm0rq">
          <div className="mx-auto max-w-2xl text-center" data-id="element-143" data-mp="1ft72f2usuqcl">
            <p className="font-bold tracking-widest text-padel-lime" data-id="element-144" data-mp="3qjs65vjut5e1">
              🏆 STOCK DIGITAL™ MÉTODO PRO-PÁDEL
            </p>
            <h2 className="mt-3 font-display text-4xl font-black text-white sm:text-5xl" data-id="element-145" data-mp="3vi3iccxmfrzf">
              Qué te llevás hoy
            </h2>
            <p className="mt-3 text-gray-300" data-id="element-146" data-mp="8eyr1yexn0jb">
              Tres recursos digitales listos para usar desde el primer día.
            </p>
          </div>
        </FadeIn>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-147" data-mp="37siubfmm24ja">
          {items.map(({
          icon: Icon,
          label,
          title,
          desc
        }, i) => <FadeIn key={title} delay={i * 0.08} data-id="element-148" data-mp="3gva65gjef2bg" data-mpi={i}>
              <article className="flex h-full flex-col rounded-2xl border border-padel-muted bg-padel-dark p-6" data-id="element-149" data-mp="3gtpebyogxxha">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-padel-muted bg-padel-surface text-padel-lime" data-id="element-150" data-mp="3lntnmol7ihlj">
                  <Icon className="h-6 w-6" data-id="element-151" data-mp="2t4o0fvwv9u4m" />
                </span>
                <span className="mt-5 text-xs font-bold uppercase tracking-[0.16em] text-padel-lime" data-id="element-152" data-mp="az7g71vrizs">
                  {label}
                </span>
                <h3 className="mt-2 font-display text-xl font-bold text-white" data-id="element-153" data-mp="3rgh61eeysges">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-400" data-id="element-154" data-mp="95dke2yxuhfq">
                  {desc}
                </p>
              </article>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.28} data-id="element-155" data-mp="3dhr7duchy8ob">
          <div className="mt-10 rounded-2xl border border-padel-lime/30 bg-padel-dark p-6" data-id="element-156" data-mp="38ied4ojapzbp">
            <div className="grid gap-3 sm:grid-cols-2" data-id="element-157" data-mp="3mi5vf1gui1vi">
              {['Acceso digital inmediato', 'Para nivel Inicial, Intermedio y Avanzado', 'Lo abrís desde el celular, tablet o computadora', 'Diseñado para el profe argentino'].map(x => <p key={x} className="text-sm text-gray-300" data-id="element-158" data-mp="wtdf1dzderzl">
                  ✅ {x}
                </p>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}